const state = {
  counter: 0
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js